import React from 'react';
import { ScrollingBanner, type ScrollingBannerProps } from '@milanlaser/mlcomponents';
import { useFirebaseMetrics } from '../../utils/useFirebaseMetrics';

interface ScrollingBannerBuilderProps extends Omit<ScrollingBannerProps, 'statements'> {
    statements?: { text: string }[];
}

export const ScrollingBannerBuilder: React.FC<ScrollingBannerBuilderProps> = (props) => {
    const { replaceVariables } = useFirebaseMetrics();
    const statements = props.statements?.map((item) => replaceVariables(item.text)) || [];

    return <ScrollingBanner {...props} statements={statements} className="[&_li]:!list-none" />;
};
